import React, { useState, useContext, useEffect, useRef, useCallback } from "react";
import { NavLink } from "react-router-dom";
import { useReactToPrint } from "react-to-print";
import moment from "moment";
//pages & includes
import ManageSidebar from "../ManageSidebar";
import FgPrint from "./FgPrint";

//functions
import {
  _t,
  getCookie,
  checkPermission,
} from "../../../../../functions/Functions";
import { useTranslation } from "react-i18next";

//axios and base url
import axios from "axios";
import { BASE_URL } from "../../../../../BaseUrl";

//3rd party packages
import { Helmet } from "react-helmet";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Moment from "react-moment";
import { MdDelete } from 'react-icons/md';

//context consumer
import { SettingsContext } from "../../../../../contexts/Settings";
import { UserContext } from "../../../../../contexts/User";
import DataTable from "../../../../common/DataTable";


const GiftHampersReturn = () => {
    const { t } = useTranslation();
    //getting context values here
    let {
      //common
      loading,
      setLoading,
    } = useContext(SettingsContext);

    let {
      authUserInfo,
    } = useContext(UserContext);

    const [giftHampersList, setGiftHampersList] = useState(null);
    const [giftHampersForSearch, setGiftHampersForSearch] = useState(null);
    const [dataPaginating, setDataPaginating] = useState(false);

    const setPaginatedGiftHampers = useCallback((pageNo = 1) => {
      if (pageNo === 1) setLoading(true);
      else setDataPaginating(true);

      const url = BASE_URL + "/settings/gift-hamper-return?page=" + pageNo;
      axios
        .get(url, {
          headers: { Authorization: `Bearer ${getCookie()}` },
        })
        .then((res) => {
          setGiftHampersList(res.data[0]);
          setGiftHampersForSearch(res.data[1]);
          
          if (pageNo === 1) setLoading(false);
          else setDataPaginating(false);
        })
        .catch(() => {
          if (pageNo === 1) setLoading(false);
          else setDataPaginating(false);
        });
    }, [setLoading]);

    useEffect(() => {
      setPaginatedGiftHampers(1);
    }, [setPaginatedGiftHampers]);
    
    let common_toast = {
      position: "bottom-center",
      autoClose: 10000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      className: "text-center toast-notification",
    }
  
    //search result
    let [searchedGifts, setSearchedGifts] = useState({
      list: [],
      searched: false,
    });
  
    const searchInputRef = useRef(null);

    //search purchase here
    const handleSearch = (e) => {
      let searchInput = e.target.value.toLowerCase();
      if (!searchInput) {
        return setSearchedGifts({ list: [], searched: false });
      }
      let searchedList = giftHampersForSearch.filter((item) => {
        let lowerCaseDocNo = item.document_identity?.toLowerCase();
        let lowerCaseItemRemarks = item.remarks?.toLowerCase();
        const branchName = item.branch_name?.toLowerCase();
        const itemName = item.item_name?.toLowerCase();
        const formattedDate = moment(item.document_date).format("MMMM D, YYYY").toLowerCase();
       
        return (
          (lowerCaseItemRemarks && lowerCaseItemRemarks.includes(searchInput)) ||
          (lowerCaseDocNo && lowerCaseDocNo.includes(searchInput)) ||
          (branchName && branchName.includes(searchInput)) ||
          (itemName && itemName.includes(searchInput)) ||
          (formattedDate && formattedDate.includes(searchInput))
        );
      });
      setSearchedGifts({
        list: searchedList,
        searched: true,
      });
    };
  
    const onClearSearch = () => {
      setSearchedGifts({ ...searchedGifts, searched: false });
      if (searchInputRef.current) {
        searchInputRef.current.value = "";
      }
    };
  
    //delete confirmation modal of waiter
    const handleDeleteConfirmation = (id) => {
      confirmAlert({
        customUI: ({ onClose }) => {
          return (
            <div className="card card-body">
              <h1>{_t(t("Are you sure?"))}</h1>
              <p className="text-center">{_t(t("You want to delete this?"))}</p>
              <div className="d-flex justify-content-center">
                <button
                  className="btn btn-primary"
                  onClick={() => {
                    handleDelete(id);
                    onClose();
                  }}
                >
                  {_t(t("Yes, delete it!"))}
                </button>
                <button className="btn btn-success ml-2 px-3" onClick={onClose}>
                  {_t(t("No"))}
                </button>
              </div>
            </div>
          );
        },
      });
    };
  
    //delete purchase here
    const handleDelete = (id) => {
      setLoading(true);
      const url = BASE_URL + `/settings/gift-hamper-return/${id}`;
      return axios
        .delete(url, {
          headers: { Authorization: `Bearer ${getCookie()}` },
        })
        .then((res) => {
          setGiftHampersList(res.data[0]);
          setGiftHampersForSearch(res.data[1]);
          setSearchedGifts({
            ...searchedGifts,
            list: res.data[1],
          });
          setLoading(false);
          toast.success(`${_t(t("Goods return has been deleted successfully"))}`, {
            position: "bottom-center",
            autoClose: 10000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            className: "text-center toast-notification",
          });
        })
        .catch(() => {
          setLoading(false);
          toast.error(`${_t(t("Please try again"))}`, common_toast);
        });
    };

    //print bills states and function
    const [newRow,setNewRow]=useState([]);
    const [documentDate,setDocumentDate]=useState(new Date());
    let [newGiftHampers, setNewGiftHampers] = useState("");
    const componentRef = useRef();
    const handleOnlyPrint = useReactToPrint({
      content: () => componentRef.current,  
      pageStyle: "@page {margin: 15px}"    
    });

    const handleGetPrintData = async(id) => {
      const url = BASE_URL + "/settings/gift-hamper-return/" + parseInt(id);
      try {
        const res = await axios
          .get(url, {
            headers: { Authorization: `Bearer ${getCookie()}` },
          });          
          if(res.data){
            let date = new Date(res.data?.document_date);
            setDocumentDate(date);
            setNewGiftHampers({
              ...newGiftHampers,
              identity: res.data.document_identity,
              branch: res.data?.branch,
              remarks: res.data?.remarks,
              ref_doc_id: res.data?.ref_document_identity,  
              item: res.data.item,
              qty: res.data.food_qty,
              rate: res.data.rate,
              amount: res.data.amount,
              total_item_qty: res.data.total_item_qty,
              total_consume_qty: res.data.total_consume_qty,
            });
            setNewRow(res.data.gift_hamper_return_details)
            
            setTimeout(() => handleOnlyPrint(), 100);
          }
      } catch(error) {
        console.log("error==>",error)
      }
    }

    //post button function
    const handlePostApi = async (id) => {
      setLoading(true);
      const url = BASE_URL + "/settings/mark-is-post-ghr"
      let formData = new FormData();
      formData.append('id',id)
      formData.append('is_post',1)
      try {
        const res = await axios.post(url, formData, {
          headers: { Authorization: `Bearer ${getCookie()}` },
        });
        if(res){
          setGiftHampersList(res.data[0]);
          setGiftHampersForSearch(res.data[1]);
          setSearchedGifts({
            ...searchedGifts,
            list: res.data[1]
          })
          toast.success(`${_t(t("Gift Hampers Return has been post"))}`,common_toast);
        }
        setLoading(false);
      } catch (err) {
        setLoading(false);
        if(err.response?.data?.message){
          toast.error(`${_t(t(err.response.data.message))}`, common_toast);
          return
        }
        toast.error(`${_t(t("Please try again"))}`,common_toast);
      }
    }

    const COLUMNS = [
      { label: "S/L", render: (item, i) => i + 1 + ((giftHampersList?.current_page || 1) - 1) * (giftHampersList?.per_page || 10) },
      { label: "Document No", render: (item) => item?.document_identity },
      { label: "Document Date", render: (item) => <Moment format="DD-MMMM-YYYY">{item.document_date}</Moment> },
      { label: "Branch", render: (item) => item.branch_name },
      { label: "Ref No.", render: (item) => item.ref_document_identity },
      { label: "Item Name", render: (item) => item.item_name },
      { label: "Food Qty", render: (item) => item.food_qty },
      {
        label: "Action",
        render: (item) => (
          <div className="d-flex justify-content-center"> 
            {item.is_post !== 1 && (
              <button
                className="btn btn-danger ml-2 rounded-sm del-btn"
                onClick={() => handleDeleteConfirmation(item.id)}                                                    
              >                                                    
                <MdDelete className="del-icon" />                                                    
              </button>
            )}
            <button
              className="btn btn-secondary ml-2 rounded-sm del-btn"
              onClick={() => handleGetPrintData(item.id)}
            >
              <i className="fa fa-print edit-icon"></i>
            </button>
            {checkPermission(authUserInfo.permissions, "Gift Hampers Post") && item.is_post !== 1 && (
              <button
                className="btn btn-dark ml-2 rounded-sm del-btn"
                title="Post goods" 
                style={{padding:"1px 0px 0px 1px"}}  
                disabled={loading}                                             
                onClick={() => handlePostApi(item.id)}
              >
                <i className="fa fa-check-square-o" aria-hidden="true"></i>
              </button>
            )}
          </div>
        )
      }
    ];

    const getListData = useCallback(() => {
      if (searchedGifts.searched) {
        return searchedGifts.list;
      }
      return giftHampersList?.data || [];
    }, [searchedGifts, giftHampersList]);

  return (
    <>
    <Helmet>
      <title>{_t(t("Gift Hampers Return"))}</title>
    </Helmet>

    {/* main body */}
    <main id="main" data-simplebar>
      <div className="container-fluid">
        <div className="row t-mt-10 gx-2">
          {/* left Sidebar */}
          <div className="col-lg-2 col-xxl-2 t-mb-30 mb-lg-0">
            <ManageSidebar />
          </div>
          {/* left Sidebar ends */}

          {/* Rightbar contents */}
          <div className="col-lg-10 col-xxl-10 t-mb-30 mb-lg-0">
            <div className="t-bg-white">
              <div className="row mx-2 gx-2 align-items-center t-pt-15 t-pb-15">
                <div className="col-md-6 col-lg-5 t-mb-15 mb-md-0">
                  <ul className="t-list fk-breadcrumb d-flex justify-content-between align-items-center">
                    <li className="fk-breadcrumb__list">
                      <span className="t-link fk-breadcrumb__link text-capitalize">
                        {_t(t("Gift Hampers Return List"))}
                      </span>
                    </li>
                  </ul>
                </div>
                <div className="col-md-6 col-lg-7">
                  <div className="row gx-3 align-items-center">
                    {/* Search group */}
                    <div className="col-md-3"></div>
                    <div className="col-md-6 t-mb-15 mb-md-0">
                      <div className="input-group">
                        <div className="form-file">
                          <input
                            type="text"
                            className="form-control border-0 form-control--light-1 rounded-left"
                            placeholder={_t(t("Search")) + ".."}
                            onChange={handleSearch}
                            disabled={loading}
                            ref={searchInputRef}
                          />
                        </div>
                        <button
                          className="btn btn-primary rounded-right"
                          type="button"
                        >
                          <i
                            className="fa fa-search"
                            aria-hidden="true"
                          ></i>
                        </button>
                      </div>
                    </div>

                    {/* Add modal trigger button */}
                    <div className="col-md-3 text-md-right">
                       <NavLink
                        to="/dashboard/manage/stock/gift-hampers-return-add"
                        className="btn btn-primary xsm-text text-uppercase btn-lg btn-block rounded"
                      >
                        {_t(t("add new"))}
                      </NavLink>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* Table */}
            <DataTable
              columns={COLUMNS}
              data={getListData()}
              emptyText="No data available"
              isLoading={loading || dataPaginating}
              pagination={{
                isPageLoading: loading || dataPaginating,
                isPagination: true,
                pageCount: giftHampersList?.last_page,
                currentPage: giftHampersList?.current_page,
                from: giftHampersList?.from,
                to: giftHampersList?.to,
                total: giftHampersList?.total,
              }}
              handleFetchData={setPaginatedGiftHampers}
              searchPayload={{
                isSearched: searchedGifts.searched,
                onClearSearch,
              }}
            />
          </div>
          {/* Rightbar contents end*/}
        </div>
      </div>
    </main>
    {/* main body ends */}
    <FgPrint
      name = "Gift Hampers Return"
      documentDate={documentDate}
      printData={newGiftHampers}
      newRow={newRow}
      print={componentRef}
    />
  </>
  )
}

export default GiftHampersReturn
